/** SAIT-138, 07.10.2026: код рейтинга грузится только возле нижней полосы футера. */
import { ref, shallowRef, onMounted, onBeforeUnmount } from 'ui.vue3';

const EXTENSION = 'vpl.tas.trust';
const NAMESPACE = 'BX.Vpl.Trust';
const LOAD_AHEAD = '200px'; // Подгружаем код до появления нижней полосы.
let loadPromise = null;

function loadExtension() {
    if (!loadPromise) {
        if (typeof BX === 'undefined' || !BX.Runtime || typeof BX.Runtime.loadExtension !== 'function') {
            return Promise.reject(new Error('vpl.tas: загрузчик расширений недоступен'));
        }
        loadPromise = BX.Runtime.loadExtension(EXTENSION).then(() => {
            const group = BX.getClass(NAMESPACE);
            if (!group || !group.FooterTrust) {
                throw new Error('vpl.tas.trust: нет FooterTrust');
            }
            return group.FooterTrust;
        }).catch((error) => {
            loadPromise = null; // После сбоя доступна повторная попытка.
            throw error;
        });
    }
    return loadPromise;
}

export function useFooterTrust(host) {
    const content = shallowRef(null);
    const loading = ref(false);
    const failed = ref(false);
    let observer = null;
    let disposed = false;

    function disconnect() {
        if (observer) {
            observer.disconnect();
            observer = null;
        }
    }

    async function load() {
        if (disposed || loading.value || content.value) {
            return;
        }
        disconnect();
        loading.value = true;
        failed.value = false;
        try {
            const component = await loadExtension();
            if (!disposed) {
                content.value = component;
            }
        } catch (_) {
            if (!disposed) {
                failed.value = true;
            }
        } finally {
            if (!disposed) {
                loading.value = false;
            }
        }
    }

    onMounted(() => {
        if (typeof IntersectionObserver === 'undefined') {
            load();
            return;
        }
        observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
                load();
            }
        }, { rootMargin: LOAD_AHEAD });
        if (host.value) {
            observer.observe(host.value);
        }
    });

    onBeforeUnmount(() => {
        disposed = true;
        disconnect();
    });

    return { content, loading, failed, load };
}
